<div class="security-auth-list">
  <div class="security-auth-list__title">
    <span>{{ 'AUTHENTICATION.TYPE_' + selectedMethod?.type | translate }}</span>
    <span class="security-auth-list__title-vpn" *ngIf="selectedMethod?.type === 'Ldap'">{{ "AUTHENTICATION.VPN_REQUIRED" | translate }}</span>
  </div>
   <div class="security-auth-list__item" *ngFor="let item of items" title="{{item.translation}}"
    [ngClass]="{'security-auth-list__item--selected': selectItemInput && ((selectItemInput.key && selectItemInput.key === item.key) || (selectItemInput.name && selectItemInput.name === item.name))}"
    (click)="onSelectItem(item)">
    <bzg-icon class="bz-space--inline-s" [nameIcon]="'icon-user-authentication'" [size]="16"></bzg-icon>
    <span>{{item.translation}}</span>
  </div>
</div>
